import React from "react";

const Swirly = ({ color, top, left, bottom, right, size }) => {
  const style = {
    top: bottom ? undefined :`${top}px`,
    left: right ? undefined : `${left}px`,
    bottom: top ? undefined :`${bottom}px`,
    right: left ? undefined : `${right}px`,
    width: `${size}px`,
    height: `${size}px`,
    position: "absolute",
  };

  if (color == "green") {
    return (
      <svg
        className="spinner-counterClockwise"
        style={style}
        width="96"
        height="88"
        viewBox="0 0 96 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 28.228C5.5 15.5613 11.8 -5.97204 25 9.22796C41.5 28.228 46 55.728 25 58.228C4 60.728 14.5 2.72796 37.5 9.22796C60.5 15.728 73 69.228 58.5 67.228C44 65.228 56 5.22795 78.5 22.728C101 40.228 91 87.728 78.5 83.728"
          stroke="#A8FFCF"
          stroke-width="7"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  if (color == "gradient") {
    return (
      <svg
        className="spinner-clockwise"
        style={style}
        width="77"
        height="71"
        viewBox="0 0 77 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9658 7.24952L21.8583 5.61602L19.9658 7.24952ZM63.9543 65.4268C62.64 65.0037 61.2315 65.7261 60.8084 67.0404C60.3853 68.3546 61.1077 69.7631 62.4219 70.1862L63.9543 65.4268ZM5.48286 22.9858C6.07957 17.9161 7.60536 11.4687 10.0157 7.86802C11.2149 6.0767 12.2613 5.52708 13.0669 5.50111C13.9257 5.47342 15.5796 5.99393 18.0732 8.88302L21.8583 5.61602C19.0199 2.32749 16.0385 0.402692 12.9058 0.503703C9.71989 0.606427 7.41857 2.75952 5.86077 5.08662C2.75727 9.72273 1.13227 17.175 0.517139 22.4014L5.48286 22.9858ZM18.0732 8.88302C24.4783 16.3038 28.4165 25.2497 28.831 32.3396C29.0372 35.866 28.3642 38.7167 26.95 40.7361C25.5832 42.6878 23.3188 44.1595 19.6685 44.5967L20.2631 49.5612C25.0956 48.9824 28.739 46.8978 31.0456 43.6042C33.3048 40.3782 34.0708 36.2943 33.8225 32.0478C33.3282 23.5921 28.7835 13.6394 21.8583 5.61602L18.0732 8.88302ZM19.6685 44.5967C18.1572 44.7777 17.1175 44.4135 16.3283 43.7821C15.4769 43.101 14.7088 41.936 14.1537 40.206C13.0331 36.7141 13.0217 31.6534 14.1297 26.4673C15.2342 21.2976 17.3683 16.3938 20.1549 13.1623C22.8949 9.98479 25.971 8.6847 29.3807 9.6542L30.7482 4.84484C24.8671 3.1726 19.9148 5.78433 16.3683 9.89705C12.8685 13.9557 10.4583 19.7205 9.24003 25.4227C8.02531 31.1084 7.91298 37.1226 9.3928 41.7338C10.1378 44.0553 11.3453 46.1988 13.2048 47.6865C15.1264 49.2237 17.5329 49.8882 20.2631 49.5612L19.6685 44.5967ZM29.3807 9.6542C33.2419 10.7521 36.9364 13.9391 40.1578 18.5131C43.3492 23.0443 45.8822 28.6677 47.5129 34.1283C49.1544 39.6254 49.8109 44.7195 49.4479 48.1975C49.2636 49.9637 48.8462 51.0102 48.4504 51.5212C48.1889 51.8587 47.9496 51.9982 47.3739 51.9183L46.6866 56.8708C49.0395 57.1974 51.0471 56.3335 52.403 54.5833C53.6245 53.0066 54.195 50.8811 54.4209 48.7165C54.8784 44.3327 54.0453 38.5296 52.3038 32.6977C50.5514 26.8293 47.8079 20.6918 44.2457 15.634C40.7136 10.6189 36.1778 6.3887 30.7482 4.84484L29.3807 9.6542ZM47.3739 51.9183C46.9038 51.8531 46.3571 51.5663 45.7955 50.5662C45.2085 49.5206 44.7535 47.9168 44.5444 45.8096C44.1285 41.6193 44.7522 36.1497 46.2913 31.0927C47.8508 25.9687 50.2069 21.7357 52.8988 19.6055C54.1907 18.5831 55.4718 18.1102 56.7633 18.1262C58.0652 18.1424 59.6894 18.6595 61.6474 20.1918L64.7288 16.2541C62.1424 14.2301 59.4873 13.1597 56.8254 13.1266C54.1533 13.0934 51.7862 14.1097 49.796 15.6846C45.9238 18.749 43.18 24.1431 41.508 29.6369C39.8155 35.1977 39.0759 41.3366 39.5689 46.3035C39.8142 48.7749 40.3817 51.1369 41.4357 53.0141C42.5152 54.9367 44.2281 56.5297 46.6866 56.8708L47.3739 51.9183ZM61.6474 20.1918C69.746 26.5293 72.281 38.6541 71.3021 49.3402C70.8183 54.6221 69.4956 59.2206 67.8229 62.2106C66.982 63.7138 66.1452 64.6442 65.4408 65.1165C64.8118 65.5383 64.3689 65.5603 63.9543 65.4268L62.4219 70.1862C64.532 70.8656 66.5506 70.3923 68.2254 69.2693C69.8247 68.1969 71.1339 66.5332 72.1865 64.6517C74.3008 60.8722 75.7553 55.5387 76.2813 49.7964C77.3221 38.434 74.8078 24.1414 64.7288 16.2541L61.6474 20.1918Z"
          fill="url(#paint0_linear_127_345)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_127_345"
            x1="3"
            y1="-11.6312"
            x2="38.8627"
            y2="67.8363"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#A8FFCF" />
            <stop offset="1" stop-color="#FFA8D8" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      className="spinner"
      width="44"
      height="40"
      viewBox="0 0 44 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M1 12.5132C1.71686 6.49395 4.72769 -3.73874 11.0361 3.48434C18.9216 12.5132 21.0722 25.5812 11.0361 26.7692C1 27.9572 6.01805 0.395526 17.01 3.48434C28.0019 6.57315 33.9757 31.9965 27.046 31.0461C20.1164 30.0957 25.8513 1.58353 36.6042 9.89956C47.3572 18.2156 42.5781 40.7877 36.6042 38.8869"
        stroke="#FFCFA8"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default Swirly;
